import { render, staticRenderFns } from "./TaskConfig.vue?vue&type=template&id=5f3d214c&"
import script from "./TaskConfig.vue?vue&type=script&lang=js&"
export * from "./TaskConfig.vue?vue&type=script&lang=js&"
import style0 from "./TaskConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports